<div class="container">
	<nb-accordion class="accordion-card">
		<nb-accordion-item expanded>
			<nb-accordion-item-header>
				<h1 class="paragraph">DETEKTO MASHTRIMIN</h1>
			</nb-accordion-item-header>
			<nb-accordion-item-body>
				<div class="d-flex">
					<p class="short-paragraph">
						Në këtë uebfaqe, janë paraqitur skenaret e ndryshëm për zbulimin e
						mashtrimit në mënyrë që përdoruesi të ekzaminoj këto të dhëna.
						Ndikimi i inxhierisë, përzgjedhja e veçorive dhe nxjerrja e
						parametrave për hulumtim janë konsideruar me qëllim të arritjes së
						një performance parashikuese sa më të avancuar.
					</p>
					<img src="../../../../../assets/images/scenario.svg" />
				</div>
			</nb-accordion-item-body>
		</nb-accordion-item>
	</nb-accordion>

	<nb-card class="white-card mt-5">
		<p class="paragraph mb-4">
			Aksidentet e përsëritura në periudhen 2 vjeçare me më shumë persona të
			involvuar
		</p>
		<p class="dark-paragraph">
			Sikurse skenari 1 edhe ky skenar i përket mashtrimit më të zakonshëm të
			aksidenteve të trafikut kur një automjet i dyshuar papritmas rrëshqet
			drejt e para makinës suaj. Këto aksidente vijojn të përsëriten më shumë se
			një herë gjatë periudhës dy vjeçare dhe personat e përfshirë në aksident
			janë të njejtë. <br />
			<br />
			Për të kontrolluar nëse aksidenti i plotëson kriteret dhe është rast
			potencial për mashtrim shkruani numrat personal të individëve të përfshirë
			në aksident dhe evidentoni gjendjen.
		</p>
	</nb-card>

	<div class="search mb-4">
		<form>
			<div>
				<div class="card-form__form">
					<input
						#newPersonalId
						type="text"
						nbInput
						name="id"
						placeholder="Kërko numrin personal…"
						minlength="10"
						maxlength="10"
						(keyup.enter)="
							onAddPersonalId(newPersonalId.value); newPersonalId.value = ''
						"
					/>

					<button
						type="button"
						(click)="
							onAddPersonalId(newPersonalId.value); newPersonalId.value = ''
						"
					></button>
					<button
						id="button"
						type="button"
						class="blue-button ml-2"
						(click)="navigateToResults()"
					>
						KËRKO
					</button>
				</div>
			</div>
			<div class="listedItems">
				<div
					class="addedItems p-2 mt-3 mr-3"
					*ngFor="let personalId of personalIdNumbers; let i = index"
				>
					<p class="blue-paragraph">
						{{ personalId }}
					</p>
					<div (click)="deletePersonalIdItem(i)">
						<nb-icon icon="close-outline"></nb-icon>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
